import ConsultaBase from "../shared/ConsultaBase";
import { centrifugaConsultaConfig } from "../config/centrifugaConsulta";

const CCentrifuga = () => {
  return <ConsultaBase config={centrifugaConsultaConfig} />;
};

export default CCentrifuga;